import { withYjs,type YjsEditor } from '@slate-yjs/core';
import type { Operation, SlateEditor } from '@udecode/plate';
import type * as Y from 'yjs';

export type WithYjsOptions = {
    autoConnect?: boolean;
    localOrigin?: unknown;
    positionStorageOrigin?: unknown;
    synchronizeValue?: boolean;
};

export type YjsEditorProps = {
    storeLocalChange: (op: Operation) => void;
} & Pick<
    YjsEditor,
    | 'applyRemoteEvents'
    | 'connect'
    | 'disconnect'
    | 'flushLocalChanges'
    | 'isLocalOrigin'
    | 'localOrigin'
    | 'positionStorageOrigin'
    | 'sharedRoot'
>;

export const withTYjs = (
    editor: SlateEditor,
    sharedRoot: Y.XmlText,
    options?: WithYjsOptions
) =>
    withYjs(editor as any, sharedRoot, options) as SlateEditor & YjsEditorProps;
